import type { ReactNode } from "react";
import styles from "./PageHeader.module.css";

type PageHeaderProps = {
  kicker: string;
  title: string;
  action?: ReactNode;
};

export const PageHeader = ({ kicker, title, action }: PageHeaderProps) => (
  <header className={styles.header}>
    <div>
      <span className={styles.kicker}>{kicker}</span>
      <h1 className={styles.title}>{title}</h1>
    </div>
    {action}
  </header>
);
